function Banner() {
  return (
    <div style={{
      position: 'relative',
      width: '100%',
      height: '100vh',
      overflow: 'hidden',
    }}>
      {/* Video Background */}
      <video 
        autoPlay 
        muted 
        loop 
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: '0'
        }}
      >
        <source src="/Cyberate Investment_final (1).mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      {/* Dark overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: '1'
      }} />
      
      {/* Text content */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        width: '90%',
        maxWidth: '1200px',
        zIndex: '2'
      }}>
        <p style={{
          fontSize: '1rem',
          color: 'white',
          marginBottom: '1rem',
          backgroundColor: '#0F7E8D',
          padding: '0.5rem',
          display: 'inline-block'
        }}>
          We help our investors succeed by innovatively analysing the market.
        </p>
        <h1 style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)',
          fontWeight: 'bold',
          color: 'white',
          marginBottom: '1rem',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
        }}>
          Dedicated to innovating the field of real estate investment by data analytics
        </h1>
      </div>
    </div>
  );
}

export default Banner; 